<template>
  <div class="message-count">
    <div class="ly-card search">
      <el-select v-model="sel" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="date"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['00:00:00', '23:59:59']"
      ></el-date-picker>
      <el-button type="primary">查询</el-button>
    </div>
    <div class="ly-card">
      <ly-table
        :getTableData="getTableData"
        :tableHeader="tableHeader"
        ref="lyTable"
      ></ly-table>
    </div>
  </div>
</template>
<script>
import { DatePicker, Select } from 'element-ui';
import LyTable from '@/components/LyTable';

export default {
  name: 'MessageCount',
  components: {
    LyTable,
    ElSelect: Select,
    ElDatePicker: DatePicker
  },
  data() {
    return {
      date: [],
      options: [],
      sel: '',
      getTableData: () => {},
      tableHeader: [
        {
          value: 'x',
          name: '部门'
        },
        {
          value: 'z',
          name: '发送条数'
        },
        {
          value: 'a',
          name: '成功条数'
        },
        {
          value: 'q',
          name: '失败条数'
        },
        {
          value: 'd',
          name: '成功率'
        }
      ]
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    search() {
      this.$refs.lyTable.setData();
    }
  }
};
</script>

<style lang="less">
.message-count {
  .search {
    text-align: right;
    >* {
      margin-left: 15px;
    }
    .el-range-separator {
      width: 40px;
    }
  }
}
</style>
